import IndustrySolutionPage from '../components/IndustrySolutionPage';
import { logisticsData } from '@/mocks/industrySolutionsData';

export default function LogisticsSolutionPage() {
  return <IndustrySolutionPage data={logisticsData} />;
}